import { LoaderCircle } from '@/shared/icons';

export function FullscreenLoader() {
  return (
    <div className="flex min-h-screen items-center justify-center" role="status" aria-live="polite">
      <LoaderCircle className="size-6 animate-spin text-brand-green-600" aria-hidden />
      <span className="sr-only">Загрузка…</span>
    </div>
  );
}
